import Typography from './Typography'

export * from './Typography'
export default Typography
